import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import OrderLinkPage from './components/OrderLinkPage';
import MesaRedirectHandler from './components/MesaRedirectHandler';
import MesaOrderPage from './components/MesaOrderPage';
import CardapioRedirectHandler from './components/CardapioRedirectHandler';
import CardapioOrderPage from './components/CardapioOrderPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Mesa QR code scan - redirects to temporary link */}
        <Route path="/mesa/:permanentUuid" element={<MesaRedirectHandler />} />

        {/* Mesa temporary menu link */}
        <Route path="/mesa-menu/:linkId" element={<MesaOrderPage />} />

        {/* Cardapio public link - redirects to temporary link */}
        <Route path="/:slug/cardapio" element={<CardapioRedirectHandler />} />

        {/* Cardapio temporary menu link */}
        <Route path="/cardapio-menu/:linkId" element={<CardapioOrderPage />} />

        {/* Delivery order link */}
        <Route path="/:linkId" element={<OrderLinkPage />} />

        <Route path="/" element={<Navigate to="/invalid" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
